
function read_cookie(key)
{
    var result;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? (result[1]) : null;
}
$(document).on('turbolinks:load', function () {

    // $('.regionlink').each(function () {
    //     var value = $(this).attr('href');
    //     var diseasestate = $('.diseasestatebutton.selected').val();
    //     $(this).attr('href', value + "?disease_state=" + diseasestate);
    //
    // })

    if (read_cookie("tparea")) {
       swap_diseasestates(read_cookie("tparea"));
    }
    if (read_cookie("confirmed")) {
      $('.popup-container').hide();

    }


    function swap_diseasestates(diseasestate) {



            $('.diseasestatebutton').removeClass('selected');
            $('.diseasestatebutton[value='+ diseasestate + ']').addClass('selected');
              var diseasestatestring = "?disease_state=" + diseasestate;
              $('.regionlink').each(function () {
                  var value = $(this).attr('href');


                      if (value.includes("?")) {
                          value = value.substring(0, value.indexOf('?'))

                      }
                      $(this).attr('href', value +diseasestatestring);
                      value = $(this).attr('href');


              })
              if (diseasestate == "psychiatry") {
                  $('.usmap').attr('class', 'usmap psychiatry')
              } else if (diseasestate == "respiratory") {
                  $('.usmap').attr('class', 'usmap respiratory')
              }else {
                  $('.usmap').attr('class', 'usmap neurology')
              }
              document.cookie = "tparea" + "=" + escape(diseasestate) + ";";

    }


    $('.diseasestatebutton').click(function (e) {


        var diseasestate = $(this).val();
        swap_diseasestates(diseasestate);

    });


    $('#hcp-confirm-form').submit(function (e) {
        e.preventDefault();
        if ($('#hcp-confirm-form')[0].checkValidity()) {
            $('.popup-container').addClass('animate__zoomOut');
             var now = new Date();
             now.setTime(now.getTime() + 1 * 3600 * 1000);
             document.cookie = "confirmed" + "=" + escape("true") + ";";
            setTimeout(function () {
                $('.popup-container').hide();
            }, 1000)
        } else {
            $('#hcp-confirm-form')[0].reportValidity()
            return false;
        }
    })
});
